import RouterView from '@/page/main/DefaultRouterView'
// 采购相关
import PurchaseApply from '@/page/purchase/purchaseApply'
import PurchaseList from '@/page/purchase/list'
import PurchaseRecord from '@/page/purchase/recordApply'
import PurchaseRecordList from '@/page/purchase/recordList'

import PurchaseApplySub from '@/page/purchase/purchaseApplySub'
import PurchaseListSub from '@/page/purchase/listSub'


import purchaseSupplier from '@/page/purchase/supplierApply'
import purchaseSupplierList from '@/page/purchase/supplierList'

export default {
  path: '/Purchase',
  component: RouterView,
  children: [{
    path: 'Apply',
    meta: {
      type: ['purchase', 'purchaseApply'],
      title: '采购申请'
    },
    component: PurchaseApply
  }, {
    path: 'List',
    meta: {
      type: ['purchase', 'purchaseList'],
      title: '采购列表'
    },
    component: PurchaseList
  }, {
    path: 'ApplySub',
    meta: {
      type: ['purchase', 'purchaseApplySub'],
      title: '子公司内部采购申请'
    },
    component: PurchaseApplySub
  }, {
    path: 'ListSub',
    meta: {
      type: ['purchase', 'purchaseListSub'],
      title: '子公司内部采购列表'
    },
    component: PurchaseListSub
  }, {
    path: 'Record',
    meta: {
      type: ['purchase', 'purchaseRecord'],
      title: '采购备案审批'
    },
    component: PurchaseRecord
  }, {
    path: 'Record/List',
    meta: {
      type: ['purchase', 'purchaseRecordList'],
      title: '采购备案列表'
    },
    component: PurchaseRecordList
  }, {
    path: 'Supplier',
    meta: {
      type: ['purchase', 'purchaseSupplier'],
      title: '供应商准入申请'
    },
    component: purchaseSupplier
  }, {
    path: 'Supplier/List',
    meta: {
      type: ['purchase', 'purchaseSupplierList'],
      title: '供应商准入申请列表'
    },
    component: purchaseSupplierList
  }, ]
}


// WEBPACK FOOTER //
// ./src/router/purchase.js